<template>
	<div class=" login-wrap clearfix">
		<div class="content_login">
			<div class="title">免密登录</div>
			<el-form :model="Register" :rules="rules" ref="RegisterForm" label-width="0" class="RegisterForm">
				<el-form-item prop="phone">
					<el-input v-model="Register.phone" v-enter-number maxlength="11" placeholder="请输入手机号"></el-input>
					<el-button type="button" @click="sendcode" :disabled="disabled" v-if="disabled==false" class="send_btn">发送验证码
					</el-button>
					<el-button type="button" @click="sendcode" :disabled="disabled" v-if="disabled==true" class="send_btn">{{btntxt}}
					</el-button>
				</el-form-item>
				<el-form-item prop="code">
					<el-input v-model="Register.code" maxlength="6" placeholder="请输入验证码"></el-input>
				</el-form-item>
			
				<el-form-item>
					<el-button type="primary" @click="submitForm(Register)">
						{{loading? '登录中...' : '登录'}}
					</el-button>
				</el-form-item>
			</el-form>
		</div>
	</div>
</template>

<script>
	let ms = []
	import {
		mapGetters
	} from 'vuex'
	import { Login, Send, Center} from '../../common/api/http.js'
	export default {
		data() {
			return {
				loading: false,
				rules: {
					phone: [{
						required: true,
						message: "请输入手机号",
						trigger: 'blur'
					}],
					code: [{
						required: true,
						message: "请输入验证码",
						trigger: 'blur'
					}]
				},
				Register: {
					phone: '',
					code: '',
				},
				disabled: false,
				time: 0,
				btntxt: "重新发送",
			}
		},
		created() {
			
		},
		mounted() {
			
		},
		computed: {
			...mapGetters([
				'adminIndex'
			])
		},
		methods: {
			//手机验证发送验证码
			sendcode() {
				const reg = 11 && /^((13|14|15|17|18)[0-9]{1}\d{8})$/
				if (this.Register.phone == '') {
					this.$message({
						message: '手机号不能为空',
						center: true
					})
					return
				}
				if (!reg.test(this.Register.phone)) {
					this.$message({
						message: '请输入正确的手机号',
						center: true
					})
					return
				} else {
					this.$message({
						message: '发送成功',
						type: 'success',
						center: true
					});
					this.time = 60;
					this.disabled = true;
					this.timer();
					
					// 请求验证码
					let data = {
						'mobile': this.Register.phone,
						'action': '2'
					}
					Send(data).then(res => {
						// console.log(res.data.code)
						this.$message('验证码:'+res.data.code)
					})
				}
			},
			//60S倒计时
			timer() {
				if (this.time > 0) {
					this.time--;
					this.btntxt = this.time + "s后重新获取";
					setTimeout(this.timer, 1000);
				} else {
					this.time = 0;
					this.btntxt = "获取验证码";
					this.disabled = false;
				}
			},
			submitForm() {
				this.$refs.RegisterForm.validate((e) => {
					if (!e) return;
					this.loading = true
					// 登录
					let data = {
						'mobile': this.Register.phone,
						'sms_code':this.Register.code,
						'type':'1'
					}
					Login(data).then(res => {
						console.log(res)
						if(res.code==0){
							// console.log(res.data.token)
							// 请求我的
							Center({
								'api_token': res.data.token
							}).then(res=>{
								// console.log(res)
								if(res.code==0){
									// 存储到vuex
									let data = res.data
									// 存储到本地存储
									this.$store.commit('login', data)
									// 成功提示
									this.$message({
									  message: '登录成功!',
									  type: 'success'
									});
									this.loading = false
									// 跳转后台首页-是否认证通过
									if(data.certified ==0){
										this.$router.push({
											name: 'unverified_state'
										})
									}else if(data.certified ==1){
										this.$router.push({
											name: 'index'
										})
									}
									
								}
							}).catch(err => {
								this.loading = false
							})
						}
					}).catch(err => {
						this.loading = false
					})
				})
			},
			submit() {
				this.$refs.ruleForm.validate((e) => {
					if (!e) return;
					// 提交表单
					this.loading = true
					this.axios.post('/admin/login', this.form).then(res => {
						// 存储到vuex
						let data = res.data.data
						// console.log(JSON.stringify(data.tree))
						// 存储到本地存储
						this.$store.commit('login', data)
						// 存储权限规则
						if (data.role && data.role.rules) {
							window.sessionStorage.setItem('rules', JSON.stringify(data.role.rules))
						}

						var tree = this.$conf.navBar
						// 生成后台菜单
						this.$store.commit('createNavBar', tree)
						// 成功提示
						this.$message('登录成功')
						this.loading = false
						// 跳转后台首页
						this.$router.push({
							name: this.adminIndex
						})
					}).catch(err => {
						this.loading = false
					})
				})
			}
		},
	}
</script>

<style lang="less">
	.el-button--primary {
		background-color: #047aff;
		border-color: #047aff; width: 100%; margin-top: 20px;
		&:hover {
			background: #047aff;
		}
	}
	html,body,#app {
		width: 100%; height: 100%;
	}
	.login-wrap {
		width: 100%; height: 100%; background: url(../../assets/login_img.jpg) center top no-repeat;
		.content_login {
			width: 418px; height: 330px; position: absolute; left: 0; top: 0; right: 0; bottom: 0; margin: auto; background: #fff; border-radius: 8px; padding: 37px 46px 42px; box-sizing: border-box;
			.send_btn {
				position: absolute; right: 12px; top: 1px; border: none; padding: 0; line-height: 38px; color:#047aff; outline: none; background: none;
				&:hover { background: none;}
			}
			.title {
				font-size: 18px; color: #333; line-height: 1; font-weight: bold; margin-bottom: 42px;
			}
		}
	}
</style>
